// extracted by mini-css-extract-plugin
export var banner = "_jc-0";
export var closeButton = "_jc-2";
export var greenCheckmark = "_jc-3";
export var hereLink = "_jc-4";
export var titleIcon = "_jc-1";